// Mock data for Al Naturale redesign. Frontend-only for now.
// Site imagery reused from the original brand where noted.

export const navLinks = [
  { label: 'Home', to: '/' },
  { label: 'About', to: '/about' },
  { label: 'Our Products', to: '/products' },
  { label: 'Our Menu', to: '/menu' },
  { label: 'Our Café', to: '/cafe' },
  { label: 'Gift Vouchers', to: '/gift-cards' },
  { label: 'Where to Buy', to: '/where-to-buy' },
  { label: 'Catering', to: '/catering' },
  { label: 'Classes & Events', to: '/classes' },
  { label: 'FAQ', to: '/faq' },
  { label: 'Blog', to: '/blog' },
  { label: 'Careers', to: '/careers' },
];

export const faqCategories = [
  {
    id: 'about-nut-milk',
    label: 'About our nut milk',
    items: [
      {
        q: 'What is nut milk?',
        a: "Al Naturale Nut Milk is a fresh, plant-based milk made from real nuts and simple ingredients. Our nut milks are crafted with activated nuts, filtered water, a date and a touch of salt, creating a naturally delicious alternative to conventional dairy milk.",
      },
      {
        q: 'What nut milk types do you offer?',
        a: 'We offer a variety of nut milks including almond, hazelnut, and walnut milk, each with its unique flavour and nutritional benefits.',
      },
      {
        q: 'Is nut milk a good source of protein?',
        a: "Nut milk contains some protein, but it is generally lower in protein compared to cow's milk. It's still a nutritious choice with other health benefits.",
      },
      {
        q: 'What are the health benefits of drinking nut milk?',
        a: 'Nut milk is rich in vitamins E and D, low in calories, free from cholesterol and lactose, and contains antioxidants and healthy fats that are good for heart and bone health.',
      },
      {
        q: 'Are your nut milks gluten-free?',
        a: 'Yes, all our nut milks are naturally gluten-free.',
      },
      {
        q: 'Is nut milk suitable for people with lactose intolerance?',
        a: 'Yes, nut milk is completely lactose-free, making it an excellent option for those with lactose intolerance.',
      },
      {
        q: 'Are your products organic and non-GMO?',
        a: 'Yes, we use organic and non-GMO ingredients in all our nut milks to ensure the highest quality.',
      },
      {
        q: 'Can I use Al Naturale nut milk in cooking and baking?',
        a: 'Definitely! Our nut milk is versatile and works well in cooking, baking, coffee, smoothies, and more.',
      },
    ],
  },
  {
    id: 'storage-safety',
    label: 'Storage & safety',
    items: [
      {
        q: 'How should I store nut milk?',
        a: 'Nut milk should be stored in the refrigerator and consumed within 7-10 days of opening.',
      },
      {
        q: 'Can I freeze nut milk?',
        a: 'Yes, you can freeze nut milk. However, it may separate upon thawing. Shaking or blending can help restore its consistency.',
      },
      {
        q: 'Are the nut milks safe for children?',
        a: "Nut milk is generally safe for children and toddlers, but it's best to consult with a pediatrician, especially for children under one year old.",
      },
      {
        q: 'How do you ensure the quality of your nut milk?',
        a: 'We follow strict quality controls and test every batch to ensure the best taste and texture.',
      },
    ],
  },
  {
    id: 'sourcing-sustainability',
    label: 'Sourcing & sustainability',
    items: [
      {
        q: 'Where do you source your nuts from?',
        a: 'We work with trusted farms that use sustainable and organic farming practices, primarily from Australia.',
      },
      {
        q: 'Is Al Naturale nut milk environmentally friendly?',
        a: "Yes, we're committed to sustainability, using recyclable packaging and partnering with eco-friendly farms.",
      },
      {
        q: 'Do you recycle or reuse packaging materials?',
        a: 'Yes, we encourage recycling and reuse. Our packaging is designed to be recyclable, and we offer a program for returning and reusing our glass bottles.',
      },
    ],
  },
  {
    id: 'ordering-wholesale',
    label: 'Ordering & wholesale',
    items: [
      {
        q: 'Is there a minimum order quantity?',
        a: 'No, you can order as few as one bottle. However, we offer discounts on bulk purchases.',
      },
      {
        q: 'Do you offer any bulk or wholesale purchasing options?',
        a: 'Yes, we provide bulk and wholesale purchasing options for businesses and larger orders. Please get in touch for more details.',
      },
      {
        q: 'Can I contact customer service with additional questions?',
        a: 'Absolutely! Reach out to us through our Where to Buy page and our team will be happy to assist you.',
      },
    ],
  },
];

export const products = [
  {
    id: 'almond-8',
    name: 'Almond Milk',
    badge: '8% Almonds',
    tagline: 'Smooth & everyday',
    price: 11.5,
    sizes: [
      { label: '750ml', price: 11.5 },
      { label: '2L', price: 24.0 },
    ],
    accent: '#D2B489',
    tone: '#F0E3CF',
    image:
      'https://static.wixstatic.com/media/53df74_790d6e83b3c7440da39256ec10a3779a~mv2.png/v1/fill/w_454,h_1384,al_c,q_90,enc_avif,quality_auto/Almond%20Milk%208%25%20lARGE.png',
    tastingNotes: 'Fine, gentle and versatile almond milk',
    description:
      'Our signature Barista almond milk is a unique selection designed to be versatile for any drink, your favourite coffee, smoothies, chai, chocolate, cooking and much more. It has the clear taste of almonds and a touch of sweetness from dates, with zero artificial colours, keeping all the nutrients and raw goodness of the almonds intact. It blends perfectly with coffee and froths for any variation you desire.',
    notes: ['20% activated nuts range', 'No gums or oils', 'No preservatives', 'Suitable for coffee'],
    uberUrl:
      'https://www.ubereats.com/au/store/al-naturale-saint-kilda/SxktCSXKVai41A1-CFGzPA?diningMode=PICKUP&mod=quickView&modctx=%257B%2522storeUuid%2522%253A%25224b192d09-25ca-55a8-b8d4-0d7e0851b33c%2522%252C%2522sectionUuid%2522%253A%2522de3d852c-9cee-4112-a236-afb8f47c5236%2522%252C%2522subsectionUuid%2522%253A%25222f8b50e9-b359-419d-b9e8-37a1ab962b5a%2522%252C%2522itemUuid%2522%253A%2522d1bc2860-4c52-4a93-aed5-1ca99caf2581%2522%252C%2522showSeeDetailsCTA%2522%253Atrue%257D&pl=JTdCJTIyYWRkcmVzcyUyMiUzQSUyMkFsJTIwTmF0dXJhbGUlMjIlMkMlMjJyZWZlcmVuY2UlMjIlM0ElMjI3NDJhYTVhNy03NDBiLTFjMTAtY2NkZC0yOTUxZTk4YzA5OGIlMjIlMkMlMjJyZWZlcmVuY2VUeXBlJTIyJTNBJTIydWJlcl9wbGFjZXMlMjIlMkMlMjJsYXRpdHVkZSUyMiUzQS0zNy44NjI1MjczJTJDJTIybG9uZ2l0dWRlJTIyJTNBMTQ0Ljk3NDM1NTElN0Q%3D&ps=1&surfaceName=',
  },
  {
    id: 'almond-20',
    name: 'Almond Milk',
    badge: '20% Almonds',
    tagline: 'The signature',
    price: 13.2,
    sizes: [
      { label: '750ml', price: 13.2 },
      { label: '2L', price: 27.0 },
    ],
    accent: '#D2B489',
    tone: '#EAD9C0',
    image:
      'https://static.wixstatic.com/media/53df74_241a6f8a427446359fce9394625408f4~mv2.png/v1/crop/x_365,y_0,w_356,h_1080/fill/w_468,h_1420,q_90,enc_avif,quality_auto/20%25%20ALMOND%20MILK%20LARGE.png',
    tastingNotes: 'Creamy, rich and intense almond flavour',
    description:
      'Designed for true almond milk drinkers who love the taste of pure almonds, without all the extra additives. The creamy texture blends and froths beautifully for coffee, a perfect match with hot and cold beverages, with a subtle sweetness that makes for a delicious ice-cold treat on its own. Made with just 4 ingredients: 20% activated almonds, filtered water, dates and a pinch of sea salt (and of course a large touch of love).',
    notes: ['Highest nut % in Australia', 'Intensely creamy', 'Single date sweetened', 'Suitable for coffee'],
    uberUrl:
      'https://www.ubereats.com/au/store/al-naturale-saint-kilda/SxktCSXKVai41A1-CFGzPA?diningMode=PICKUP&mod=quickView&modctx=%257B%2522storeUuid%2522%253A%25224b192d09-25ca-55a8-b8d4-0d7e0851b33c%2522%252C%2522sectionUuid%2522%253A%2522de3d852c-9cee-4112-a236-afb8f47c5236%2522%252C%2522subsectionUuid%2522%253A%25222f8b50e9-b359-419d-b9e8-37a1ab962b5a%2522%252C%2522itemUuid%2522%253A%25221d2b7bcc-544f-48d4-aa0d-20d8ea7b8086%2522%252C%2522showSeeDetailsCTA%2522%253Atrue%257D&pl=JTdCJTIyYWRkcmVzcyUyMiUzQSUyMkFsJTIwTmF0dXJhbGUlMjIlMkMlMjJyZWZlcmVuY2UlMjIlM0ElMjI3NDJhYTVhNy03NDBiLTFjMTAtY2NkZC0yOTUxZTk4YzA5OGIlMjIlMkMlMjJyZWZlcmVuY2VUeXBlJTIyJTNBJTIydWJlcl9wbGFjZXMlMjIlMkMlMjJsYXRpdHVkZSUyMiUzQS0zNy44NjI1MjczJTJDJTIybG9uZ2l0dWRlJTIyJTNBMTQ0Ljk3NDM1NTElN0Q%3D&ps=1&surfaceName=',
  },
  {
    id: 'walnut',
    name: 'Walnut Milk',
    badge: '12% Walnuts',
    tagline: 'Earthy & bold',
    price: 13.2,
    sizes: [
      { label: '750ml', price: 13.2 },
      { label: '2L', price: 27.0 },
    ],
    accent: '#7A5433',
    tone: '#E8DAC6',
    image:
      'https://static.wixstatic.com/media/53df74_d9a63caeed0341fd8fb78898f0f3ee1c~mv2.png/v1/fill/w_454,h_1384,al_c,q_90,enc_avif,quality_auto/Walnut%20Milk%20Large.png',
    tastingNotes: 'Buttery, decisive, creamy texture with deep notes of a lingering nutty smooth taste',
    description:
      'When it comes to walnut milk, less is definitely more. Drinking our Walnut Milk is like drinking freshly cracked walnuts, creamy and indulgent, satisfying in so many variations, and a must with coffee. It froths beautifully for all your favourite lattes and cappuccinos, and is the perfect addition to your morning coffee or cereal, with all the beneficial goodness of walnuts.',
    notes: ['Activated walnuts', 'Omega rich', 'Bold flavour', 'Suitable for coffee'],
    uberUrl:
      'https://www.ubereats.com/au/store/al-naturale-saint-kilda/SxktCSXKVai41A1-CFGzPA?diningMode=PICKUP&mod=quickView&modctx=%257B%2522storeUuid%2522%253A%25224b192d09-25ca-55a8-b8d4-0d7e0851b33c%2522%252C%2522sectionUuid%2522%253A%2522de3d852c-9cee-4112-a236-afb8f47c5236%2522%252C%2522subsectionUuid%2522%253A%25222f8b50e9-b359-419d-b9e8-37a1ab962b5a%2522%252C%2522itemUuid%2522%253A%2522f95459a4-3772-4971-a594-0b186e3229f7%2522%252C%2522showSeeDetailsCTA%2522%253Atrue%257D&pl=JTdCJTIyYWRkcmVzcyUyMiUzQSUyMkFsJTIwTmF0dXJhbGUlMjIlMkMlMjJyZWZlcmVuY2UlMjIlM0ElMjI3NDJhYTVhNy03NDBiLTFjMTAtY2NkZC0yOTUxZTk4YzA5OGIlMjIlMkMlMjJyZWZlcmVuY2VUeXBlJTIyJTNBJTIydWJlcl9wbGFjZXMlMjIlMkMlMjJsYXRpdHVkZSUyMiUzQS0zNy44NjI1MjczJTJDJTIybG9uZ2l0dWRlJTIyJTNBMTQ0Ljk3NDM1NTElN0Q%3D&ps=1&surfaceName=',
  },
  {
    id: 'hazelnut',
    name: 'Hazelnut Milk',
    badge: '12% Hazelnuts',
    tagline: 'Nutella bliss',
    price: 13.2,
    sizes: [
      { label: '750ml', price: 13.2 },
      { label: '2L', price: 27.0 },
    ],
    accent: '#8A5A2B',
    tone: '#EEDDC5',
    image:
      'https://static.wixstatic.com/media/53df74_9435b2d12ad84d53a3aeb00ab005f43d~mv2.png/v1/fill/w_466,h_1414,al_c,q_90,enc_avif,quality_auto/large%20Hazelnut%20Milk.png',
    tastingNotes: 'Natural, sweet & distinctive taste, finishing with a long-lasting nutty hazelnut character',
    description:
      'Made with only the freshest whole hazelnuts and a touch of natural sweetness, our unique hazelnut milk is free from pesky fillers, additives and preservatives, nothing but the good stuff. It has a deliciously nutty taste that pairs perfectly with hot chocolate, and just like our almond milks it froths easily, making it perfect for your daily coffee, your favourite recipes, or simply enjoyed on its own.',
    notes: ['Toasted hazelnuts', 'Naturally sweet', 'Dessert in a glass', 'Suitable for coffee'],
    uberUrl:
      'https://www.ubereats.com/au/store/al-naturale-saint-kilda/SxktCSXKVai41A1-CFGzPA?diningMode=PICKUP&mod=quickView&modctx=%257B%2522storeUuid%2522%253A%25224b192d09-25ca-55a8-b8d4-0d7e0851b33c%2522%252C%2522sectionUuid%2522%253A%2522de3d852c-9cee-4112-a236-afb8f47c5236%2522%252C%2522subsectionUuid%2522%253A%25222f8b50e9-b359-419d-b9e8-37a1ab962b5a%2522%252C%2522itemUuid%2522%253A%252287551e03-4933-463a-8ad6-a13ad2629e33%2522%252C%2522showSeeDetailsCTA%2522%253Atrue%257D&pl=JTdCJTIyYWRkcmVzcyUyMiUzQSUyMkFsJTIwTmF0dXJhbGUlMjIlMkMlMjJyZWZlcmVuY2UlMjIlM0ElMjI3NDJhYTVhNy03NDBiLTFjMTAtY2NkZC0yOTUxZTk4YzA5OGIlMjIlMkMlMjJyZWZlcmVuY2VUeXBlJTIyJTNBJTIydWJlcl9wbGFjZXMlMjIlMkMlMjJsYXRpdHVkZSUyMiUzQS0zNy44NjI1MjczJTJDJTIybG9uZ2l0dWRlJTIyJTNBMTQ0Ljk3NDM1NTElN0Q%3D&ps=1&surfaceName=',
  },
];

export const images = {
  careersHeader:
    'https://customer-assets-0z36b82j.emergentagent.net/job_fresh-italiano/artifacts/q9amp87p_image.png',
  hero:
    'https://static.wixstatic.com/media/53df74_a79d09ac51924d979d1c523e2bb4032b~mv2.jpg/v1/fill/w_1905,h_1015,fp_0.43_0.27,q_90,enc_avif,quality_auto/hero.jpg',
  bottleFlatlay:
    'https://customer-assets-0z36b82j.emergentagent.net/job_fresh-italiano/artifacts/lu4vdxdm_image.png',
  productsLineup:
    'https://customer-assets-0z36b82j.emergentagent.net/job_fresh-italiano/artifacts/dfz5lnr0_image.png',
  whereHeader:
    'https://customer-assets-0z36b82j.emergentagent.net/job_fresh-italiano/artifacts/cb9p5g43_image.webp',
  blogHeader:
    'https://customer-assets-0z36b82j.emergentagent.net/job_fresh-italiano/artifacts/jvktosjv_image.png',
  cafeStorefront:
    'https://customer-assets-0z36b82j.emergentagent.net/job_fresh-italiano/artifacts/8agxbryo_image.png',
  cafeBarista:
    'https://customer-assets-0z36b82j.emergentagent.net/job_fresh-italiano/artifacts/ghj5r1i0_image.png',
  cafeTable:
    'https://customer-assets-0z36b82j.emergentagent.net/job_fresh-italiano/artifacts/k9ech73v_image.png',
  cafeInterior:
    'https://customer-assets-0z36b82j.emergentagent.net/job_fresh-italiano/artifacts/r4zvu0dk_image.png',
  cafeCroissant:
    'https://customer-assets-0z36b82j.emergentagent.net/job_fresh-italiano/artifacts/ivz0vjvc_image.png',
  pour:
    'https://static.wixstatic.com/media/53df74_a197f84e69f943f2ad50a3ab240cbf63~mv2.jpg/v1/fill/w_1000,h_1100,al_c,q_90,enc_avif,quality_auto/pour.jpg',
  founder:
    'https://customer-assets-0z36b82j.emergentagent.net/job_fresh-italiano/artifacts/ncrvns2r_image.png',
  band:
    'https://static.wixstatic.com/media/53df74_5f0c17357e27406980d155b931dc2a12~mv2.jpg/v1/fill/w_1905,h_640,fp_0.50_0.46,q_90,enc_avif,quality_auto/band.jpg',
  latte1:
    'https://images.unsplash.com/photo-1583507623011-5cc6ff99e11c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHw0fHxsYXR0ZSUyMGFsbW9uZCUyMG1pbGt8ZW58MHx8fHwxNzg4NDk4NTU4fDA&ixlib=rb-4.1.0&q=85',
  latte2:
    'https://images.unsplash.com/photo-1680901106907-3374ffaa25c6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHxsYXR0ZSUyMGFsbW9uZCUyMG1pbGt8ZW58MHx8fHwxNzg4NDk4NTU4fDA&ixlib=rb-4.1.0&q=85',
  latte3:
    'https://images.unsplash.com/photo-1601436423581-9c59173e52d4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwzfHxsYXR0ZSUyMGFsbW9uZCUyMG1pbGt8ZW58MHx8fHwxNzg4NDk4NTU4fDA&ixlib=rb-4.1.0&q=85',
  cafe1:
    'https://images.unsplash.com/photo-1611238763458-0de1027136cf?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800',
  pugliaAlley:
    'https://images.unsplash.com/photo-1779909016665-95f773118499?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  cafe2:
    'https://images.unsplash.com/photo-1593548615309-5a45c504f994?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxpdGFsaWFuJTIwY2FmZXxlbnwwfHx8fDE3ODg0OTg1NTh8MA&ixlib=rb-4.1.0&q=85',
  cafe3:
    'https://images.unsplash.com/photo-1579926545913-448d525562db?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwzfHxpdGFsaWFuJTIwY2FmZXxlbnwwfHx8fDE3ODg0OTg1NTh8MA&ixlib=rb-4.1.0&q=85',
  brunch1:
    'https://images.unsplash.com/photo-1504754524776-8f4f37790ca0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxicmVha2Zhc3QlMjBicnVuY2h8ZW58MHx8fHwxNzg4NDk4NTU4fDA&ixlib=rb-4.1.0&q=85',
  brunch2:
    'https://images.unsplash.com/photo-1538220856186-0be0e085984d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHw0fHxicmVha2Zhc3QlMjBicnVuY2h8ZW58MHx8fHwxNzg4NDk4NTU4fDA&ixlib=rb-4.1.0&q=85',
  brunch3:
    'https://images.unsplash.com/photo-1528699633788-424224dc89b5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxicmVha2Zhc3QlMjBicnVuY2h8ZW58MHx8fHwxNzg4NDk4NTU4fDA&ixlib=rb-4.1.0&q=85',
};

export const founder = {
  name: 'Marialuisa',
  from: 'Monopoli, Puglia',
  year: 2013,
  body: `Marialuisa arrived in Australia in 2013 carrying the essence of Monopoli, a sun-washed town on the Puglian coast where life turns on freshness and simplicity. Believing food is woven into our happiness, she searched for an almond milk that truly tasted of almonds. She never found one that met her standards. So she made her own: an almond milk with 20% activated almonds, the highest percentage of nuts in Australia.`,
};

export const mission = `From slow mornings to long lunches, our St Kilda café serves a full menu of all-day breakfast and lunch, fresh, seasonal dishes and Italian-inspired brunch made daily, poured with our own nut milks and barista coffee.`;

export const secretRecipe = {
  title: 'Our Secret Recipe',
  body: `A generous blend of high-quality activated nuts, filtered water, a single date for sweetness, a touch of salt, and love. Each sip delivers the natural richness of activated nuts in perfect balance. More than a drink; a commitment to quality and wellness in every bottle.`,
  steps: [
    { n: '01', t: 'Activate', d: 'Nuts are soaked and activated to unlock flavour and nutrition.' },
    { n: '02', t: 'Blend', d: 'Stone-blended with filtered water for a silky, full body.' },
    { n: '03', t: 'Sweeten', d: 'A single date and a whisper of salt, nothing more.' },
    { n: '04', t: 'Bottle', d: 'Fresh, small-batch, no gums, oils or preservatives.' },
  ],
};

export const customCakes = {
  heading: 'Custom cakes, made to order',
  intro: "Tell us about your dream cake and we'll craft something special. Tick anything that applies and share the details below.",
  checklist: [
    { group: 'Occasion', options: ['Birthday', 'Wedding', 'Engagement', 'Anniversary', 'Baby shower', 'Corporate / event', 'Other'] },
    { group: 'Flavour', options: ['Vanilla', 'Chocolate', 'Red velvet', 'Carrot', 'Lemon', 'Pistachio', 'Tiramisu'] },
    { group: 'Dietary', options: ['Gluten free', 'Vegan', 'Dairy free', 'Nut free', 'Egg free', 'Refined-sugar free'] },
    { group: 'Finishing touches', options: ['Custom message / topper', 'Fresh flowers', 'Multi-tier', 'Printed photo / image', 'Specific colour theme'] },
  ],
};


export const reviewsAggregate = { rating: 4.8, count: null };

export const reviews = [
  {
    author: 'Sophie Brandl',
    rating: 5,
    time: '2 months ago',
    quote:
      "Absolutely delicious food! Looked so aesthetic and tasted amazing, I had the french toast and it was probably the best one I've ever had. I also tried the tiramisu latte and it was divine. The staff are super friendly and I felt so welcome. Probably the best café in St Kilda.",
    role: '2 months ago',
  },
  {
    author: 'Ciara Lawne',
    rating: 5,
    time: '2 months ago',
    quote:
      'I usually thoroughly vet places as a coeliac, but stumbled across this spot with gluten-free focaccia and was pleasantly surprised. We got one with prosciutto, mozzarella and the perfect amount of pesto, fresh, good quality and so delicious! The cannoli were perfectly crunchy with a beautiful creamy filling.',
    role: '2 months ago',
  },
  {
    author: 'K Mc',
    rating: 5,
    time: '7 months ago',
    quote:
      "Delicious. I'm an eggs Benedict fiend and this place didn't disappoint, creamy, unbroken hollandaise, eggs perfect, ham thin and perfectly salty. The focaccia was a nice twist. Hubs had the egg scramble with stracciatella and spicy sausage, and he was happy.",
    role: '7 months ago',
  },
  {
    author: 'Marina Alefosio',
    rating: 5,
    time: '2 months ago',
    quote:
      'Beautiful meals and coffee. I ordered the shakshuka and enjoyed every bite, as well as the lovely service by Antonia. Would eat this again, especially in winter time. Thanks so much!',
    role: '2 months ago',
  },
  {
    author: 'Marisa Adams',
    rating: 4,
    time: '7 months ago',
    quote:
      'Yum yum yum, all the way. This place is a hidden delight. My chilli scramble was subtle but ever so flavoursome, and they make their own milks too. Just behind the Prince in Acland St.',
    role: '7 months ago',
  },
  {
    author: 'Emily Rumer',
    rating: 5,
    time: '6 months ago',
    quote:
      'We had the double focaccia and both were delicious. The location and decor were lovely and a very relaxing vibe. Would happily come back on our next trip to Melbourne.',
    role: '6 months ago',
  },
];

export const menu = [
  {
    category: 'Coffee & Lattes',
    note: 'Made with your choice of our house nut milks',
    items: [
      { name: 'Espresso', price: 4.0, desc: 'Single origin, rich crema' },
      { name: 'Cappuccino', price: 5.0, desc: 'Silky micro-foam, cocoa dusting' },
      { name: 'Flat White', price: 5.0, desc: 'Best with our 20% almond' },
      { name: 'Turmeric Latte', price: 6.5, desc: 'Golden, warming, house favourite' },
      { name: 'Matcha Latte', price: 6.5, desc: 'Ceremonial grade, hazelnut milk' },
      { name: 'Hot Chocolate', price: 6.0, desc: 'Belgian cocoa, walnut milk' },
    ],
  },
  {
    category: 'All Day Brunch',
    note: 'Fresh, local, made in-house',
    items: [
      { name: 'Ricotta & Honey Toast', price: 14.0, desc: 'Sourdough, whipped ricotta, honeycomb' },
      { name: 'Avocado Smash', price: 18.0, desc: 'Feta, chilli, lemon, dukkah' },
      { name: 'Italian Frittata', price: 17.0, desc: 'Zucchini, parmigiano, fresh herbs' },
      { name: 'Acai Bowl', price: 16.0, desc: 'Granola, seasonal fruit, almond milk' },
      { name: 'Prosciutto Panini', price: 15.0, desc: 'Focaccia, buffalo mozzarella, rocket' },
    ],
  },
  {
    category: 'Dolci',
    note: 'A sweet taste of Puglia',
    items: [
      { name: 'Tiramisu', price: 9.5, desc: 'Classic, espresso-soaked, mascarpone' },
      { name: 'Sicilian Cannoli', price: 8.0, desc: 'Crisp shell, sweet ricotta, pistachio' },
      { name: 'Cornetto', price: 5.5, desc: 'Buttery, freshly baked each morning' },
    ],
  },
];

export const locations = [
  {
    id: 'cafe',
    name: 'Al Naturale Café',
    type: 'Flagship Café',
    address: '6 Acland Street, St Kilda VIC 3182',
    phone: '0470 696 842',
    hours: 'Mon-Sun · 7am to 3pm · Breakfast & lunch',
    lat: -37.8683,
    lng: 144.98,
  },
  {
    id: 'market-organic',
    name: 'Market Organic',
    type: 'Market Stall',
    address: 'Queen Victoria Market, Queen St, Melbourne VIC 3000',
    hours: 'Market trading days',
    lat: -37.8076,
    lng: 144.9568,
  },
  {
    id: 'moses-co',
    name: 'Moses & Co',
    type: 'Market Stall',
    address: 'South Melbourne Market, Cnr Coventry & Cecil St, South Melbourne VIC 3205',
    hours: 'Market trading days',
    lat: -37.8323,
    lng: 144.9563,
  },
  {
    id: 'terramadre',
    name: 'Terramadre',
    type: 'Stockist',
    address: '103 High Street, Northcote VIC 3070',
    lat: -37.769,
    lng: 144.999,
  },
  {
    id: 'dragonfly',
    name: 'Dragonfly Café & Deli',
    type: 'Stockist',
    address: '130 High Street, Preston VIC 3072',
    phone: '0488 097 797',
    lat: -37.7407,
    lng: 145.0006,
  },
  {
    id: 'ladybird',
    name: 'Ladybird Organics',
    type: 'Stockist',
    address: '130 Puckle Street, Moonee Ponds VIC 3039',
    phone: '(03) 9370 2874',
    lat: -37.7645,
    lng: 144.9205,
  },
  {
    id: 'lamanna',
    name: 'LaManna Direct',
    type: 'Stockist',
    address: '10 English Street, Essendon Fields VIC 3041',
    phone: '(03) 9026 9205',
    lat: -37.7268,
    lng: 144.9016,
  },
  {
    id: 'officine-zero',
    name: 'Officine Zero',
    type: 'Stockist',
    address: '534 Malvern Road, Prahran VIC 3181',
    phone: '(03) 9533 2724',
    lat: -37.8556,
    lng: 145.0003,
  },
  {
    id: 'glo-health',
    name: 'Glo Health',
    type: 'Stockist',
    address: '358-360 Glen Huntly Road, Elsternwick VIC 3185',
    phone: '(03) 9523 7824',
    lat: -37.8853,
    lng: 145.0035,
  },
  {
    id: 'organic-fix',
    name: 'Organic Fix',
    type: 'Stockist',
    address: '937 Main Road, Eltham VIC 3095',
    phone: '(03) 9424 1861',
    lat: -37.7155,
    lng: 145.1468,
  },
  {
    id: 'cos-cheltenham',
    name: 'C.O.S Cheltenham Organic Store',
    type: 'Stockist',
    address: '360 Reserve Road, Cheltenham VIC 3192',
    phone: '(03) 9583 8754',
    lat: -37.964,
    lng: 145.048,
  },
  {
    id: 'edigrocer',
    name: 'Edigrocer',
    type: 'Stockist',
    address: '280 Nepean Hwy, Edithvale VIC 3196',
    lat: -38.0378,
    lng: 145.1076,
  },
  {
    id: 'ceres-fair-food',
    name: 'Ceres Fair Food Organic',
    type: 'Online',
    address: 'Online · 20 Water Rd, Preston VIC 3072',
    hours: 'Home delivery across Melbourne',
    lat: -37.735,
    lng: 145.01,
  },
];

export const blogPosts = [
  {
    id: 'why-20-percent',
    title: 'Why 20% almonds changes everything',
    excerpt:
      'Most almond milks contain 2-3% almonds. We use 20% activated almonds, here is what that does to flavour, body and nutrition.',
    date: 'June 12, 2025',
    read: '4 min',
    image:
      'https://images.unsplash.com/photo-1583507623011-5cc6ff99e11c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHw0fHxsYXR0ZSUyMGFsbW9uZCUyMG1pbGt8ZW58MHx8fHwxNzg4NDk4NTU4fDA&ixlib=rb-4.1.0&q=85',
    tag: 'Craft',
  },
  {
    id: 'activated-nuts',
    title: 'The art of activating nuts',
    excerpt:
      'Soaking and activating is our first ritual each morning. It unlocks flavour, reduces bitterness and makes every bottle more digestible.',
    date: 'May 28, 2025',
    read: '5 min',
    image:
      'https://images.unsplash.com/photo-1601436423581-9c59173e52d4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwzfHxsYXR0ZSUyMGFsbW9uZCUyMG1pbGt8ZW58MHx8fHwxNzg4NDk4NTU4fDA&ixlib=rb-4.1.0&q=85',
    tag: 'Behind the scenes',
  },
  {
    id: 'puglia-to-st-kilda',
    title: 'From Puglia to St Kilda',
    excerpt:
      'How a search for real almond milk turned a Monopoli childhood into a little piece of Italy on Acland Street.',
    date: 'May 03, 2025',
    read: '6 min',
    image:
      'https://images.unsplash.com/photo-1690061522073-f54dec2099f4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
    tag: 'Our story',
  },
  {
    id: 'perfect-turmeric-latte',
    title: 'The perfect turmeric latte at home',
    excerpt:
      'Our most-ordered drink, decoded. The right ratio of spice, warmth and almond milk for a golden cup every time.',
    date: 'April 18, 2025',
    read: '3 min',
    image:
      'https://images.unsplash.com/photo-1680901106907-3374ffaa25c6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHxsYXR0ZSUyMGFsbW9uZCUyMG1pbGt8ZW58MHx8fHwxNzg4NDk4NTU4fDA&ixlib=rb-4.1.0&q=85',
    tag: 'Recipes',
  },
];

export const contact = {
  address: '6 Acland Street, St Kilda VIC 3182',
  phone: '0470 696 842',
  email: 'hello@alnaturale.com.au',
  instagram: '@alnaturalecafe',
};

export const social = {
  instagramHandle: '@alnaturalecafe',
  instagramUrl: 'https://www.instagram.com/alnaturalecafe/',
  googleReviewUrl:
    'https://www.google.com/search?tbnid=SAeiEx11mrhs2M&tbnh=0&tbnw=0&sa=X&sca_esv=d50c116370280445&cs=0&sxsrf=APpeQnvRamBaEITa38ib8CrRFjB7h_VKFA:1788754951286&q=al+naturale&si=APenkKm7iecQ4G6P-TsbSMFKIQtv3EFIqRAFw-i8uEbk55Z-_6zmLwCPt4WDcc8iJVKGaTDErfUAs5RPJ6ijkPIDHnqWrCFk9KOBKvpw9FqCJRoU8ykXf7laHBEf5u_z6sfHHHKzbGLa4fpqjAxuwFXJ8RGmRGRFHA%3D%3D&ved=2ahUKEwj0o9i7z9uWAxWhjeEIHaMONX0QrrQLegQIHhAA&biw=1920&bih=945&dpr=1',
};

export const ordering = {
  doordashUrl:
    'https://www.doordash.com/store/al-naturale-cafe-6-acland-street-st-kilda-51809683/118314147/?pickup=true&rwg_token=AE37R_g8Fnn718iSZxMrgBGDrXpyF957Ccy5Cku7uLJnkF7oeSoHuJCcPeToLZldcLhkoYopnEnqUyo3tYoYJReI9lKngIYK3Q==&utm_campaign=gpa',
  ubereatsUrl:
    'https://www.ubereats.com/au/store/al-naturale-saint-kilda/SxktCSXKVai41A1-CFGzPA?diningMode=PICKUP&pl=JTdCJTIyYWRkcmVzcyUyMiUzQSUyMkFsJTIwTmF0dXJhbGUlMjIlMkMlMjJyZWZlcmVuY2UlMjIlM0ElMjI3NDJhYTVhNy03NDBiLTFjMTAtY2NkZC0yOTUxZTk4YzA5OGIlMjIlMkMlMjJyZWZlcmVuY2VUeXBlJTIyJTNBJTIydWJlcl9wbGFjZXMlMjIlMkMlMjJsYXRpdHVkZSUyMiUzQS0zNy44NjI1MjczJTJDJTIybG9uZ2l0dWRlJTIyJTNBMTQ0Ljk3NDM1NTElN0Q%3D&ps=1&surfaceName=',
};

// The full cafe menu is presented as designed panels on the original site.
// The full cafe menu is presented as designed panels on the original site (11 pages).
const MENU_IDS = [
  'da696e031704432f9f97ffe381c5eae4',
  'f8e4cfc8c7e34274adb775453cc3e0d8',
  '9e9b757c367845f0826c2e0f2ebc60cd',
  '081a25ea05944653b93b971395201de6',
  '33f644e3c5274561b19caad6b132f6e8',
  '9c03117e87ea4cbebe1c0db623bd5860',
  'c9b324f16e084406bda9e868ceff1440',
  'efb3a2613fd8447fa65eff195d9a31d1',
  '38b3b69ef882441aa52b316abbd7d8c1',
  '7a3e5aa682104489b5a2261febf4a818',
  'e65bd3c3812d40a18fc7f61cb19976fc',
];

export const menuImages = MENU_IDS.map(
  (id) =>
    `https://static.wixstatic.com/media/743422_${id}~mv2.png/v1/fit/w_1400,h_1400,q_90,enc_avif,quality_auto/menu.png`
);

export const cafe = {
  hero:
    'https://customer-assets-0z36b82j.emergentagent.net/job_fresh-italiano/artifacts/rxbvup6g_image.png',
  welcome: 'Welcome to Al Naturale Café',
  hours: 'Monday to Sunday · 7am to 3pm',
  note: 'Breakfast & lunch only',
  address: '6 Acland Street, St Kilda VIC 3182',
  body: `Step off Acland Street and into a little corner of Puglia. Every cup of coffee and every plate is crafted with love using our fresh, homemade nut milk and locally-sourced ingredients. Cosy, sunlit and unmistakably Italian, come for a taste test, stay for the turmeric latte.`,
  gallery: [images.cafeInterior, images.cafeTable, images.cafeCroissant, images.cafeStorefront],
};

export const specials = {
  image:
    'https://static.wixstatic.com/media/743422_72ab3c155b1c46279caf2db4db46231a~mv2.png/v1/fill/w_1075,h_720,fp_0.45_0.50,q_90,enc_avif,quality_auto/web%20booklet.png',
  bookletUrl:
    'https://www.alnaturale.com.au/_files/ugd/743422_2fd24ecf9cee4b9fa20296bb40acd957.pdf',
  voucherUrl:
    'https://www.alnaturale.com.au/_files/ugd/0757c3_e652134267344a35b4e8e36c92dcff15.pdf',
};

export const about = {
  founderImage: images.founder,
  headerImage:
    'https://customer-assets-0z36b82j.emergentagent.net/job_fresh-italiano/artifacts/imwqo7ea_image.png',
  intro:
    "Our promise to you is that each milk is made to the highest quality using a large amount of nutritious nuts.",
  storyParas: [
    "\u201CComing from a little town called Monopoli in the south of Italy (Puglia), I was always surrounded by the gifts of mother nature. Crystal clear ocean, a sun that warms up the soul, majestic century\u2019s trees, fresh local produce, the smell of the food as you are walking by, and this is how you will end up having the best moments of your life that are so memorable and alive within you, no matter how many years pass by\u201D",
    "Marialuisa believes in the value of eating real food and being present. She says that these important cornerstones are what shapes our relationship with food. Give yourself the best gift you can, time. Take the time to enjoy what you truly love.",
    "\u201CWe can have multiple houses, marriages, cars, success, but what is for sure we only have one body in one life... Make sure you take a good care\u201D",
  ],
  quote:
    "We can have multiple houses, marriages, cars, success, but what is for sure we only have one body in one life... Make sure you take a good care.",
  quoteBy: "Marialuisa, Founder",
  values: [
    { icon: 'Leaf', title: 'Pure & honest', body: 'Never any gums, oils, additives or preservatives. What you read on the label is all that is in the bottle.' },
    { icon: 'Sprout', title: 'Activated nuts', body: 'Every batch begins by soaking and activating our nuts to unlock flavour, nutrition and a silkier body.' },
    { icon: 'Heart', title: 'Made with love', body: 'Small-batch and handmade in Melbourne, the way Marialuisa learned to cook in Puglia.' },
    { icon: 'MapPin', title: 'Proudly local', body: 'We partner hand-in-hand with trusted local suppliers to source the very finest ingredients.' },
  ],
  stats: [
    { value: '20%', label: 'Activated almonds' },
    { value: '2013', label: 'Puglia to Melbourne' },
    { value: '0', label: 'Additives, ever' },
    { value: '4', label: 'Homemade nut milks' },
  ],
};
